/**
 * @file lifecycle.js
 * @location src/store/reducers/taskActions/crud/lifecycle.js
 * @role 업무 생성·편집·상태 토글 액션 (lifecycle)
 *
 *  ADD_TASK             새 업무 추가 (id=newId('task'), createdAt, aor=현재 uid)
 *  EDIT_TASK            부분 필드 업데이트
 *  TOGGLE_TASK          완료 ↔ 미착수 전환
 *
 *  구 TOGGLE_STATUS (todo↔in_progress) 는 razor ㉓ 로 폐기 — IN_PROGRESS 상태 폐기.
 */
import { STATUS } from '../../../../data/labels.js';
import { newId } from '../../../../utils/ids.js';

export const lifecycleActions = {
  ADD_TASK: (state, action) => {
    const isSelf = action.task.aee === state.uid;
    return {
      ...state,
      tasks: [...state.tasks, {
        id: newId('task'),
        createdAt: new Date().toISOString(),
        ...action.task,
        status: STATUS.TODO,
        aor: state.uid,
        ...(isSelf ? { acknowledgedAt: new Date().toISOString() } : {}),
      }],
    };
  },

  EDIT_TASK: (state, action) => ({
    ...state,
    tasks: state.tasks.map(t => {
      if (t.id !== action.id) return t;
      const next = { ...t, ...action.changes };
      if ('aee' in action.changes && action.changes.aee !== t.aee) {
        next.acknowledgedAt = null;
      }
      return next;
    }),
  }),

  TOGGLE_TASK: (state, action) => ({
    ...state,
    tasks: state.tasks.map(t => {
      if (t.id !== action.id) return t;
      // razor: 읽음 처리 안 된 업무는 완료 토글 불가 — 핸드셰이크(읽음→완료) 보호
      if (!t.acknowledgedAt) return t;
      if (t.status === STATUS.CANCELLED) return t;
      if (t.status === STATUS.DONE) {
        // 완료 취소 → completedAt 제거
        const { completedAt: _c, ...rest } = t;
        return { ...rest, status: STATUS.TODO };
      }
      return { ...t, status: STATUS.DONE, completedAt: new Date().toISOString() };
    }),
  }),

  CANCEL_TASK: (state, action) => {
    const now = new Date().toISOString();
    return {
      ...state,
      tasks: state.tasks.map(t =>
        t.id !== action.id ? t : {
          ...t,
          status: STATUS.CANCELLED,
          cancelledAt: now,
          cancelReason: action.reason,
        }
      ),
    };
  },

};
